import { ref, getCurrentInstance } from 'vue';

export default function useAppLanguage() {
    const defaultLang = 'en';
    const supportedLangs = [
        {
            id: 'en',
            name: 'English',
        },
        {
            id: 'nl',
            name: 'Nederlands',
        },
        {
            id: 'fr',
            name: 'Français',
        },
    ];

    const instance = getCurrentInstance();
    const vm = instance?.proxy || instance;
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if (!vm) throw new Error('vue not initialized');

    const isSupported = (lang) => {
        return (
            supportedLangs &&
            supportedLangs.some((x) => {
                return x.id == lang;
            })
        );
    };

    const getBrowserLocale = (options = {}) => {
        const defaultOptions = { countryCodeOnly: false };
        const opt = { ...defaultOptions, ...options };
        const navigatorLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language;
        if (!navigatorLocale) {
            return undefined;
        }
        const trimmedLocale = opt.countryCodeOnly ? navigatorLocale.trim().split(/-|_/)[0] : navigatorLocale.trim();
        return trimmedLocale;
    };

    const handleAppLanguage = (lang, source) => {
        if (lang) {
            localStorage.setItem('appLanguage', lang);
            localStorage.setItem('appLanguageSource', source);
            document.querySelector('html').setAttribute('lang', lang);
        } else {
            lang = localStorage.getItem('appLanguage');
            source = localStorage.getItem('appLanguageSource');
        }
        if (!lang) {
            //no language set
            var preferredLanguage = null;
            //1. Language in user profile
            if (currentUser) {
                preferredLanguage = currentUser.profile.preferredLanguage;
                source = 'profile';
            }

            if (!preferredLanguage) {
                //2 No language in user profile: use browser locale
                preferredLanguage = getBrowserLocale({
                    countryCodeOnly: true,
                });
                source = 'browser';
            }

            if (isSupported(preferredLanguage)) {
                //2. locale is supported
                lang = preferredLanguage;
            } else {
                //3. locale not supported: use default
                lang = defaultLang ? defaultLang : 'en';
                source = 'default';
            }
            localStorage.setItem('appLanguage', lang);
            localStorage.setItem('appLanguageSource', source);
            document.querySelector('html').setAttribute('lang', lang);
        }
        if (source == 'browser') {
            //if language is set by browser check if user has locale, if so use that.
            if (currentUser) {
                preferredLanguage = currentUser.profile.preferredLanguage;
                lang = preferredLanguage ? preferredLanguage : lang;
                localStorage.setItem('appLanguage', lang);
                localStorage.setItem('appLanguageSource', 'profile');
            }
        }
        //update moment is available
        if (vm.$moment) {
            vm.$moment.locale(lang);
        }
        //update i18n if available
        if (vm.$i18n) {
            vm.$i18n.locale = lang;
        }
        return lang;
    };

    const updateAppLanguage = (lang) => {
        if (isSupported(lang)) {
            //only assign when supported
            locale.value = handleAppLanguage(lang, 'application');
        }
        return locale.value;
    };

    var locale = ref();
    locale.value = handleAppLanguage();

    return { locale, updateAppLanguage };
}
